import Guid from '@/app/utils/guid'

export default abstract class Entity {

  public id = Guid.empty()
}
